export default __webpack_public_path__ + "static/media/deposit-qrcode-step3-option1.305b49d1.png";